import React, { useCallback, useEffect, useState } from 'react';
import * as S from '../Partners/styles';
import axios from 'axios';
import moment from 'moment';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";
import { getTableRowClass, getAnalysisStatusSiglum, getAnalysisStatusColor, getAnalysisStatus} from "../../utils/utils"
import { Tooltip } from '@mui/material';
import { Check, ErrorOutline } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
    tableStyle: {
      border: "none",
      boxShadow: "none",
    },
    tableText: {
      fontFamily: "Open Sans",
      fontWeight: 'normal',
      fontSize: "12px",
      lineHeight: "24px",
      color: "#333",
      textAlign: "center",
      margin: "10px",
      padding: "6px",
    },
    tableHeader: {
      textAlign: "center",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "normal",
      color: '#6F6F6F',
      fontSize: "14px",
      lineHeight: "19px",
      padding: "6px",
    }
  }));

export default function FinalBeneficiariesTable(props) {

    const classes = useStyles();
    useTheme();

    const [beneficiaries, setBeneficiaries] = useState([])

    const classifyBeneficiaries = useCallback(() => {
        return (props.partners || []).filter((partner) => partner.is_bureau_final_beneficiary)
    }, [props.partners])

    useEffect(() => {
        setBeneficiaries(classifyBeneficiaries());
    }, [classifyBeneficiaries])

    return (
        <S.Container>
            <S.Title>Quadro de Beneficiários Finais Analisados</S.Title>
            {beneficiaries.length > 0 ?
                <Paper className={classes.tableStyle}>
                    <Table style={{ padding: "8px" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableHeader}>Nome</TableCell>
                                <TableCell className={classes.tableHeader}>CPF</TableCell>
                                <TableCell className={classes.tableHeader}>Participação</TableCell>
                                <TableCell className={classes.tableHeader}>Data de ingresso mais antiga</TableCell>
                                <TableCell className={classes.tableHeader}>PEP/Relacionado</TableCell>
                                <TableCell className={classes.tableHeader}>Status da Análise</TableCell>
                                <TableCell className={classes.tableHeader}>Validação</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {beneficiaries.map((beneficiary, index) => (
                                <NaturalBeneficiary natural_person={beneficiary} index={index}/>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
                :
                <div style={{color: '#6f6f6f', width: '100%', textAlign: 'center', padding: '16px 0'}}>Informação indisponível</div>
            }
        </S.Container>
    );
}

function retrieve_latest_valid_analysis_status_event_index(analysis_status_events) {
    for (let i = analysis_status_events.length - 1; i >= 0; i--) {
        if (analysis_status_events[i].decision_metadata && ['in_manual_analysis', 'automatically_approved', 'automatically_reproved'].includes(analysis_status_events[i].new_status)) {
            return i;
        }
    }
    return analysis_status_events.length - 1;
}

function TranslateValidation(props) {
    const {bureau, payload} = props
    if (bureau && payload) {
        return (
            <Tooltip title="Beneficiário validado na base de dados" placement='left'>
                <Check style={{color: '#73c580', width: "22px", height: "22px", margin: 0}} />
            </Tooltip>
        )
    } else if (bureau && !payload) {
        return (
            <Tooltip title="Beneficiário não fornecido, mas encontrado na base de dados" placement='left'>
                <ErrorOutline style={{color: '#ddbb08', width: "22px", height: "22px", margin: 0}} />
            </Tooltip>
        )
    } else if (!bureau && payload) {
        return (
            <Tooltip title="Beneficiário fornecido não encontrado na base de dados" placement='left'>
                <ErrorOutline style={{color: '#ddbb08', width: "22px", height: "22px", margin: 0}} />
            </Tooltip>
        )
    }
    return <></>
}

function formatParticipation(finalBeneficiary) {
    if (!finalBeneficiary || finalBeneficiary.participation_percentage === undefined || finalBeneficiary.participation_percentage === null) {
        return '-'
    }
    return `${finalBeneficiary.participation_percentage}%`
}

function formatEntryDate(finalBeneficiary) {
    if (!finalBeneficiary || !finalBeneficiary.first_entry_date) {
        return '-'
    }
    return moment(finalBeneficiary.first_entry_date).format('DD/MM/YYYY')
}

function NaturalBeneficiary (props) {

    const classes = useStyles();
    useTheme();

    const [beneficiary, setBeneficiary] = useState();
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const finalBeneficiary = props.natural_person.final_beneficiary

    const retrieveBeneficiary = useCallback(async () => {
        if (props?.natural_person.natural_person_key) {
            setLoading(true);
            const response = await axios.get(`/dash/onboarding/natural_person/${props.natural_person.natural_person_key}`)
            if (response?.status === 200) {
                setBeneficiary(response.data);
                setLoading(false);
            } else {
                setError(true);
                setLoading(false)
            }
        } else {
            setBeneficiary(props.natural_person);
            setLoading(false);
        }
    }, [props.natural_person])

    useEffect(() => {retrieveBeneficiary()}, [retrieveBeneficiary]);

    if (error || loading) {
        return (
            <></>
        );
    }

    if (beneficiary) {

        const parsedBeneficiary = parseNaturalBeneficiary(beneficiary, props.natural_person.is_bureau_partner, props.natural_person.is_payload_partner);

        return (
            <>
                <TableRow
                    key={props.index}
                    className={getTableRowClass(props.index)}
                >
                    <TableCell className={classes.tableText}>
                        {parsedBeneficiary.natural_person_key !== undefined ?
                            <Tooltip title={`${parsedBeneficiary.has_negative_flags ? 'Há' : 'Não há'} apontamentos para essa análise de beneficiário`} placement="right">
                                <div style={{display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center', color: "#0b1f82", width: 'fit-content'}}>
                                    {parsedBeneficiary.has_negative_flags ?
                                        <ErrorOutline style={{color: '#D91A1A', width: "16px", height: "16px", margin: 0}} /> :
                                        <Check style={{color: '#73c580', width: "16px", height: "16px", margin: 0}} />
                                    }
                                    <Link className="link" to={"/natural-person/" + parsedBeneficiary.natural_person_key}>
                                        <p style={{margin: 0}}>{parsedBeneficiary.name}</p>
                                    </Link>
                                </div>
                            </Tooltip> : <p style={{margin: 0}}>{parsedBeneficiary.name}</p>
                        }
                    </TableCell>
                    <TableCell className={classes.tableText}>{parsedBeneficiary.document_number}</TableCell>
                    <TableCell className={classes.tableText}>{formatParticipation(finalBeneficiary)}</TableCell>
                    <TableCell className={classes.tableText}>{formatEntryDate(finalBeneficiary)}</TableCell>
                    <TableCell className={classes.tableText}>
                        <PepBadge pep={parsedBeneficiary.pep} related_pep={parsedBeneficiary.related_pep} />
                    </TableCell>
                    <TableCell className={classes.tableText}>
                        <Tooltip placement="right" title={getAnalysisStatus(parsedBeneficiary.analysis_status)}>
                            <div className={["circle", "small"].join(" ")} style={{backgroundColor: getAnalysisStatusColor(parsedBeneficiary.analysis_status)}}>
                                {getAnalysisStatusSiglum(parsedBeneficiary.analysis_status)}
                            </div>
                        </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableText}>
                        <TranslateValidation bureau={parsedBeneficiary.bureau} payload={parsedBeneficiary.payload} />
                    </TableCell>
                </TableRow>
            </>
        );
    }

    return <></>;
}

function parseNaturalBeneficiary(beneficiary, isBureau, isPayload) {

    if (!beneficiary.natural_person_key) {
        return {
            document_number: beneficiary.document_number,
            name: beneficiary.name,
            analysis_status: "not_analised",
            bureau: isBureau,
            payload: isPayload
        }
    }

    const valid_index = retrieve_latest_valid_analysis_status_event_index(beneficiary.analysis_status_events || []);

    const parsed = {
        natural_person_key: beneficiary.natural_person_key,
        analysis_status: beneficiary?.analysis_status,
        document_number: beneficiary?.document_number,
        name: beneficiary.analysis_status_events[valid_index]?.decision_metadata?.registration_data?.name?.description ?? (beneficiary?.name ?? '-'),
        pep: beneficiary.analysis_status_events[valid_index]?.decision_metadata?.pep,
        related_pep: beneficiary.analysis_status_events[valid_index]?.decision_metadata?.related_pep,
        has_negative_flags: hasNegativeFlags(beneficiary?.analysis_status_events[valid_index]?.decision_metadata),
        bureau: isBureau,
        payload: isPayload
    }

    return parsed;
}

function PepBadge(props) {
    if (props?.pep?.flag === 'negative') {
        return (
            <Tooltip title={props.pep.description} placement='right'>
                <S.RedBadge>
                    Sim
                </S.RedBadge>
            </Tooltip>
        )
    } else if (props?.related_pep?.flag === 'negative') {
        return (
            <Tooltip title={props.related_pep.description} placement='right'>
                <S.RedBadge>
                    Sim
                </S.RedBadge>
            </Tooltip>
        )
    } else if (props?.pep?.flag === 'positive') {
        return (
            <Tooltip title={props.pep.description} placement='right'>
                <S.GreenBadge>
                    Não
                </S.GreenBadge>
            </Tooltip>
        )
    }
    return (<>-</>)
}

function hasNegativeFlags(metadata) {
    if (typeof metadata !== 'object' || metadata === null) {
        return false;
      }

      for (const key in metadata) {
        if (key === 'flag' && metadata[key] === 'negative') {
          return true;
        }
        if (typeof metadata[key] === 'object' && hasNegativeFlags(metadata[key])) {
          return true;
        }
      }

      return false;
    }
